<template>
  <span></span>
</template>
<script>
export default {
  data: () => ({}),
  methods: {
    GetExpiringTemplates(){
      this.$store
        .dispatch("GET_USER_EXPIRING_TEMPLATES")
        .then(()=>{})
        .catch((error)=> {
            window.console.log(error);
        })
    },
    ConnectAccessHub() {
      this.$store
        .dispatch("CONNECT_HUB")
        .then(() => {})
        .catch((error) => {
      
          window.console.error(error);
        });
    },
    SetCountUnreadMessages() {
      var countUnreadMessages = this.$store.getters.COUNT_UNREAD_MESSAGES + 1;
      this.$store.commit("SET_COUNT_UNREAD_MESSAGES", countUnreadMessages);
    },
    SetCountUnreadArticles(){
      if (this.$store.getters.COUNT_UNREAD_ARTICLES == 0){
        this.$store.commit("SET_COUNT_UNREAD_ARTICLES", 1);
        this.SetCountUnreadMessages();
      }
    },
    GetCountUnreadMessages() {
      this.$store
        .dispatch("COUNT_UNREAD_MESSAGES")
        .then()
        .catch((error) => {
          window.console.log(error);
        });
    },
    AddUnreadArticleCount() {
      this.$store
        .dispatch("ADD_UNREAD_ARTICLE_COUNT")
        .then()
        .catch((error) => {
          window.console.log(error);
        });
    },
    GetAds() {
      this.$store
        .dispatch("ADS")
        .then(() => {})
        .catch(() => {});
    },
    CurrentUserActions() {
      this.$store
        .dispatch("CURRENT_USER_ACTIONS")
        .then(() => {})
        .catch(() => {});
    },
  },
  created() {
    var expNoticeLoaded = this.$store.getters.GET_EXP_NOTICE;
    if (!expNoticeLoaded)
      this.GetExpiringTemplates();
    this.CurrentUserActions();
    this.GetCountUnreadMessages();
    this.AddUnreadArticleCount();
    // Реклама грузится до подключения чата: от ADS зависит рендер списка товаров на «Потребности»,
    // и любая ошибка при подключении хаба не должна оставлять ADS пустым (см. hub.js SET_HUB_CONNECTION).
    this.GetAds();
    try {
      this.ConnectAccessHub();
      const hub = this.$store.getters.HUB_CONNECTION;
      if (hub) {
        hub.on("ReceivedSendToEveryone", this.SetCountUnreadArticles);
        hub.on("ReceivedToOne", this.SetCountUnreadMessages);
      }
    } catch (error) {
      // чат без соединения — не повод ломать остальное приложение
      window.console.error("Chat hub initialization failed", error);
    }
  },
};
</script>
